// extracted by mini-css-extract-plugin
export var menu_mobile = "Menu-module--menu_mobile--iAWGd";
export var menu_mobile_header = "Menu-module--menu_mobile_header--3TwZk";
export var menu_mobile_list = "Menu-module--menu_mobile_list--dQowV";
export var menu_mobile_footer = "Menu-module--menu_mobile_footer--T3cCo";
export var menu_mobile_footer_social = "Menu-module--menu_mobile_footer_social--2w8kW";
export var menu_mobile_footer_icon = "Menu-module--menu_mobile_footer_icon---NvuJ";
export var menu_mobile_copy = "Menu-module--menu_mobile_copy--y8Qk1";
export var menu = "Menu-module--menu--gMYLp";
export var active = "Menu-module--active--V4D6T";